module.exports = __webpack_public_path__ + "images/settings@3x.png?43491cca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settings@3x.png
// module id = 700
// module chunks = 7